import React from "react";
import { Logo } from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#FCFBF8] flex">
      {/* Left hero (desktop) */}
      <div className="hidden lg:flex w-1/2 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1639374937078-886e07d66ca3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Happy dog"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2D2B2A]/80 via-[#2D2B2A]/25 to-transparent" />
        <div className="relative mt-auto p-12 text-white">
          <h2 className="font-display text-4xl font-black leading-tight max-w-md">
            Calm, clear answers for every woof.
          </h2>
          <p className="mt-3 text-white/85 max-w-md">
            AI canine health guidance and trusted local vets, whenever you need them.
          </p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <Logo size={40} to="/" />
          <h1 className="font-display text-3xl font-extrabold mt-8 text-[#2D2B2A]">{title}</h1>
          {subtitle && <p className="text-[#4A4746] mt-1.5">{subtitle}</p>}
          <div className="mt-7">{children}</div>
          {footer && <div className="mt-6 text-sm text-[#4A4746] text-center">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function Field({ label, error, children }) {
  return (
    <div className="mb-4">
      <label className="block text-sm font-bold text-[#2D2B2A] mb-1.5">{label}</label>
      {children}
      {error && <p className="text-[#D9534F] text-sm mt-1">{error}</p>}
    </div>
  );
}

export const inputClass =
  "w-full rounded-2xl border border-[#E8E3DA] bg-white px-4 py-3 text-[#2D2B2A] outline-none focus:border-[#E86A45] focus:ring-2 focus:ring-[#F6DED5] transition-all placeholder:text-[#9A938B]";
